import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { Field } from 'react-final-form';
import classNames from 'classnames/bind';
import { bool, func, shape, string } from 'prop-types';
import { LockFilled } from "../../../icons";
import { TextBase } from "../../../internal/TextBase";
import Checkbox from '../../../Checkbox';
import { requiredValidation } from '../../helpers';
import styles from './Info.css';
var cx = classNames.bind(styles);
export var Info = function Info(_ref) {
  var mobile = _ref.mobile,
      disabled = _ref.disabled,
      agreementShort = _ref.agreementShort,
      themeCheckbox = _ref.themeCheckbox,
      onChangeMore = _ref.onChangeMore,
      messages = _ref.messages;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('root')
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('security')
  }, /*#__PURE__*/React.createElement(LockFilled, {
    color: "N100"
  }), /*#__PURE__*/React.createElement(TextBase, _extends({
    color: "N100"
  }, mobile ? {
    size: 's'
  } : {}), messages.security)), /*#__PURE__*/React.createElement("div", {
    className: cx('agreement')
  }, /*#__PURE__*/React.createElement(Field, {
    name: "agreement",
    type: "checkbox",
    validate: requiredValidation(messages.required)
  }, function (_ref2) {
    var input = _ref2.input,
        meta = _ref2.meta;
    return /*#__PURE__*/React.createElement(Checkbox, _extends({}, input, {
      invalid: meta.invalid && meta.touched,
      theme: themeCheckbox,
      disabled: disabled
    }), mobile ? /*#__PURE__*/React.createElement(React.Fragment, null, agreementShort ? messages.agreementShort : messages.agreement, "\xA0", /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: cx('more'),
      onClick: onChangeMore
    }, /*#__PURE__*/React.createElement(TextBase, {
      size: "m",
      as: "span",
      color: "G600"
    }, agreementShort ? messages.more : messages.hide))) : messages.agreement);
  })));
};
Info.propTypes = process.env.NODE_ENV !== "production" ? {
  mobile: bool,
  disabled: bool,
  agreementShort: bool,
  themeCheckbox: string,
  onChangeMore: func,
  messages: shape({
    security: string,
    required: string,
    agreementShort: string,
    agreement: string,
    more: string,
    hide: string
  })
} : {};
Info.defaultProps = {
  messages: {}
};